// extracted by mini-css-extract-plugin
export default {"container":"_Y-z","list":"aZ-z"};